import Vue from "vue";
import Slideshow from "./slideshow.vue";


window.addEventListener("DOMContentLoaded", (e) => {
  const slideshows = document.querySelectorAll("[data-slideshow-overlay]");
  slideshows.forEach((el) => {
    el.addEventListener("click", (e) => { slideshowClickHandler(e, 0); });
  });

  const url = new URL(window.location.href);
  const slideshow = url.searchParams.get("slideshow");
  let index = url.searchParams.get("slide");
  if (index === null) {
    index = url.searchParams.get("slide_index");
  }
  let parsedSlideshow = Number.parseInt(slideshow);
  let parsedIndex = Number.parseInt(index, 10);

  if (Number.isInteger(parsedIndex) && parsedIndex >= 0) {
    let el = document.querySelector(`[data-slideshow-overlay="${parsedSlideshow}"]`);
    el.click(e, parsedIndex);
  }
});

function getMetaImageURL() {
  return document.head.querySelector("[property~='og:image'][content]").content;
}

function slideshowClickHandler(e, index) {
  e.preventDefault();

  const overlayNode = document.querySelector("[data-overlay-vue-container]");
  const slideshowId = parseInt(e.currentTarget.getAttribute('data-slideshow-overlay'));

  let shouldOpen = true;
  let originalMetaImageURL = getMetaImageURL();

  const template = `
    <Slideshow
      :slideshowId=slideshowId
      :index=index
      v-if="open"
      @close="close()"
      @setMetaImage="setMetaImage"
      >
    </Slideshow>
    <div
      v-else
      data-overlay-vue-container>
    </div>
  `;

  new Vue({
    el: overlayNode,
    components: { Slideshow },

    data: {
      slideshowId: slideshowId,
      index: index,
      open: shouldOpen,
      originalMetaImageURL: originalMetaImageURL,
    },

    methods: {
      close() {
        this.open = false;
        window.MoMA.ScrollManager.enableScroll();
        const params = new URLSearchParams(location.search);
        params.delete("slideshow");
        params.delete("slide_index");
        params.delete("slide");

        this.setMetaImage(this.originalMetaImageURL);
        window.history.replaceState({}, "", `${location.pathname}?${params}`);
      },

      setMetaImage(imageUrl) {
        document.querySelector("[property='og:image']").setAttribute("content", imageUrl);
      },
    },

    template: template
  });
}
